import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { CreateMRForm } from '../../components/stores/CreateMRForm';

export default function MobileMR() {
  const navigate = useNavigate();
  return (
    <div className="p-3" data-testid="mobile-mr-page">
      <CreateMRForm compact onCreated={(r) => { toast.success(`${r.mr_no || 'MR'} raised`); navigate('/m'); }} />
    </div>
  );
}
